function devTricker_changeReadingListIconTo(style) {
    const iconElement = document.getElementById('add-reading-list-button-svg');
    if (!iconElement) return;

    iconElement.classList.remove('icon-thin-bookmark', 'icon-thin-bookmark-fill');

    const newClass = style === 'fill' ? 'icon-thin-bookmark-fill' : 'icon-thin-bookmark';
    iconElement.classList.add(newClass);
}

function devtricker_changeReadingListTooltipTextTo(text) {
    const button = devtricker_dom_getReadingListButton();
    if (button) {
        let bootstrapTooltip = bootstrap.Tooltip.getInstance(button);
        if (bootstrapTooltip) {
            bootstrapTooltip.setContent({ '.tooltip-inner': text });
        }
    }
}

function devtricker_dom_getReadingListButton(){
    return document.getElementById('add-reading-list-button');
}

function devtricker_changeTooltipButtonTextToV2(button, text) {
    if (button) {
        let bootstrapTooltip = bootstrap.Tooltip.getInstance(button);
        if (bootstrapTooltip) {
            bootstrapTooltip.setContent({ '.tooltip-inner': text });
        }
    }
}